import React, { useState, useEffect } from 'react';
import { HiChevronLeft, HiChevronRight } from 'react-icons/hi';
import { motion } from 'framer-motion';
import { images } from '../../constants';

import { AppWrap, MotionWrap } from '../../wrapper';
import './Testimonial.scss';

const testimonial_01 = [
  {
    name: 'Kaushik Biswas',
    imgurl: `${images.testimonial_01}`,
    feedback: 'Sameeksh is a very talented person, very hardworking, always ready to learn & grow. Someday I know he would do great things in life. I wish him all the very best for the future.',
    company: 'CX Researcher IDP'
  }
]

const brand_01 = [
  {
    _id: 1,
    name: "Git",
    imgUrl: `${images.freecodecamp}`
  },
  {
    _id: 2,
    name: "React",
    imgUrl: `${images.postman}`
  },
  {
    _id: 3,
    name: "Redux",
    imgUrl: `${images.ineuron}`
  },
  {
    _id: 4,
    name: "Sass",
    imgUrl: `${images.sstc}`
  }
]

const Testimonial = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [testimonials, setTestimonials] = useState([]);
  const [brands, setBrands] = useState([]);

  const handleClick = (index) => {
    setCurrentIndex(index);
  };

  useEffect(() => {
    
    
      setTestimonials(testimonial_01);
    

    
      setBrands(brand_01);
    
  }, []);

  return (
    <>
      <h2 className="head-text">What <span>Testimonials</span> Say...</h2>
      
      {testimonials.length && (
        <>
          <div className="app__testimonial-item app__flex">
            
            <img src={testimonials[currentIndex].imgurl} alt={testimonials[currentIndex].name} />
            <div className="app__testimonial-content">
              <p className="p-text">{testimonials[currentIndex].feedback}</p>
              <div>
                <h4 className="bold-text">{testimonials[currentIndex].name}</h4>
                <h5 className="p-text">{testimonials[currentIndex].company}</h5>
              </div>
            </div>
          </div>

          <div className="app__testimonial-btns app__flex">
            <div className="app__flex" onClick={() => handleClick(currentIndex === 0 ? testimonials.length - 1 : currentIndex - 1)}>
              <HiChevronLeft />
            </div>

            <div className="app__flex" onClick={() => handleClick(currentIndex === testimonials.length - 1 ? 0 : currentIndex + 1)}>
              <HiChevronRight />
            </div>
          </div>
        </>
      )}

      <div className="app__testimonial-brands app__flex">
        {brands.map((brand) => (
          <motion.div
            whileInView={{ opacity: [0, 1] }}
            transition={{ duration: 0.5, type: 'tween' }}
            key={brand._id}
          >
            <img src={brand.imgUrl} alt={brand.name} />
          </motion.div>
        ))}
      </div>
    </>
  );
};

export default AppWrap(
  MotionWrap(Testimonial, 'app__testimonial'),
  'testimonial',
  'app__primarybg',
);

// export default Testimonial;